package com.tixforgigs.common.core.models.embed

import kotlinx.serialization.Serializable

@OptIn(ExperimentalJsExport::class)
@Serializable
data class PostMessageHandshakeDTO(
  val handshake: String = "tixforgigs-handshake"
)
